import { createAction, props } from '@ngrx/store';
import { DataType, DataTypeCreate, DataTypeUpdate } from '../../services/model';
export const fetchDataTypes = createAction('[DataType] Fetch All');

export const loadDataTypes = createAction('[DataType] Load All Success', props<{ dataTypes: DataType[] }>());

export const createDataType = createAction('[DataType] Create', props<{ dataType: DataTypeCreate }>());

export const updateDataType = createAction('[DataType] Update', props<{ dataType: DataTypeUpdate }>());

export const deleteDataType = createAction('[DataType] Delete', props<{ id: string }>());
